var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrypto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5C22.6046 21.5 23.5 20.6046 23.5 19.5C23.5 18.3954 22.6046 17.5 21.5 17.5C20.3954 17.5 19.5 18.3954 19.5 19.5C19.5 20.6046 20.3954 21.5 21.5 21.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.5C17.5 12.6867 17.1481 13.8467 16.4888 14.8334C15.8295 15.8201 14.8925 16.5892 13.7961 17.0433C12.6997 17.4974 11.4933 17.6162 10.3295 17.3847C9.16558 17.1532 8.09648 16.5818 7.25736 15.7426C6.41825 14.9035 5.8468 13.8344 5.61529 12.6705C5.38378 11.5067 5.5026 10.3003 5.95673 9.2039C6.41085 8.10754 7.17989 7.17047 8.16658 6.51118C9.15328 5.85189 10.3133 5.5 11.5 5.5C13.0913 5.5 14.6174 6.13214 15.7426 7.25736C16.8679 8.38258 17.5 9.9087 17.5 11.5V11.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.5H27.5V27.5H8.5C7.70435 27.5 6.94129 27.1839 6.37868 26.6213C5.81607 26.0587 5.5 25.2956 5.5 24.5V19.5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.5L10.5 12.5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/Crypto.90cc8181148a5bf98fe7344eff8b19f6.svg";
export { ForwardRef as ReactComponent };